import React from 'react';
import classes from './ResetPassword.module.scss';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { Input } from '../../../components/forms/Input';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { ResetPasswordMutationVariables } from '../../../models/graphql';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { InputTypes } from '../../../constants/form';
import { SubmitHandler } from 'react-hook-form/dist/types/form';

export type ResetPasswordViewProps = {
  //
  email: string;
  formInstance: UseFormReturn<ResetPasswordMutationVariables>;
  loading: boolean;
  requestError: string | JSX.Element;
  onSubmit: SubmitHandler<ResetPasswordMutationVariables>;
  passwordRules: RegisterOptions;
  passwordType: InputTypes.password | InputTypes.text;
  resetPasswordData?: boolean;
  setPasswordFieldState: VoidFunction;
  passwordActionButton: SquareButtonIconsEnum.show | SquareButtonIconsEnum.hide;
  tokenRules: RegisterOptions;
};

export const ResetPasswordView = (props: ResetPasswordViewProps): JSX.Element => {
  const formClasses = classNames('grid-x grid-padding-x', { hide: props.resetPasswordData });
  const infoMessage = props.resetPasswordData ? (
    <>
      <p>Your new password has been saved.</p>
      <p>
        Please{' '}
        <Link reloadDocument to={'/login'}>
          log in
        </Link>
        .
        {/* TODO remove reloadDocument once React app is the only app - we need reloadDocument to load legacy login portal.*/}
      </p>
    </>
  ) : (
    <>
      <p>
        You requested to reset your password for <strong>{props.email}</strong>.
      </p>
      <p> Please enter your new password.</p>
    </>
  );
  // we need to cast UseFormReturn<T> back to UseFormReturn
  const formInstance: UseFormReturn = props.formInstance as unknown as UseFormReturn;
  return props.requestError ? (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Reset Your Password</h2>
      </div>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'error'}>{props.requestError}</BoxNotification>
      </div>
    </div>
  ) : (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Reset Your Password</h2>
      </div>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'info'}>{infoMessage}</BoxNotification>
      </div>
      <form className={formClasses} onSubmit={props.formInstance.handleSubmit(props.onSubmit)}>
        <div className={'cell small-12 margin-bottom-small-26'}>
          <Input
            disabled={props.loading}
            formInstance={formInstance}
            name={'password'}
            type={props.passwordType}
            size={'large'}
            inlinedLabel
            helper={'This password must be at least 8 characters long'}
            label={'Password'}
            rules={props.passwordRules}
            action={() => {
              props.setPasswordFieldState();
            }}
            actionButton={{ icon: props.passwordActionButton }}
          />
          <Input
            disabled={props.loading}
            formInstance={formInstance}
            name={'token'}
            type={InputTypes.hidden}
            size={'large'}
            inlinedLabel
            rules={props.tokenRules}
          />
        </div>
        <div className={'cell small-12'}>
          <Button
            type={'submit'}
            variant={'solid'}
            size={'large'}
            expanded
            disabled={props.loading}
            color={ButtonColorsEnum.secondary}
            loading={props.loading}>
            Save Password
          </Button>
        </div>
      </form>
    </div>
  );
};
